/**
 * @generated SignedSource<<76500d1bc480ed6104a051d9e948d9b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksPlusWidgetConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hooksPlusWidgetConfigQuery";
};
export type hooksPlusWidgetConfigQuery$key = {
  readonly " $data"?: hooksPlusWidgetConfigQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksPlusWidgetConfigQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksPlusWidgetConfigQuery",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "scmp_pwa_settings"
          }
        }
      ],
      "concreteType": "AppConfig",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "133afb2fe7de5b1ef322f86fb478dd69";

export default node;
